import { getIdOrNull, requestWithPromise } from '..'
import { HttpMethods } from '../apiHelper'

export const createActTypeCategory = (user, body) => {
  return requestWithPromise(
    '/api/act-type-categories',
    HttpMethods.POST,
    body,
    user
  )
}

export const updateActTypeCategory = (user, actTypeCategory, body) => {
  return requestWithPromise(
    `/api/act-type-categories/${getIdOrNull(actTypeCategory)}`,
    HttpMethods.PATCH,
    body,
    user
  )
}

export const deleteActTypeCategory = (user, actTypeCategory) => {
  return requestWithPromise(
    `/api/act-type-categories/${getIdOrNull(actTypeCategory)}`,
    HttpMethods.DELETE,
    null,
    user
  )
}
